{
	"flag": "🇳🇴",
	"common": {
		"add": "Legg til",
		"create": "Opprett",
		"e-mail": "E-post",
		"edit": "Redigere",
		"language": "Språk",
		"no": "Nei",
		"or": "Eller",
		"password": "Passord",
		"save": "Lagre",
		"select": "Velg",
		"selected": "Valgt",
		"select-all": "Velg alle",
		"selected-all": "Valgte alle",
		"sign-out": "Logg ut",
		"username": "Brukernavn",
		"yes": "Ja",
		"saving": "Lagrer",
		"delete": "Fjerne",
		"next": "Neste",
		"get-started": "Kom i gang",
		"skip": "Hopp over",
		"optional": "valgfri",
		"read-more": "Les mer",
		"show-less": "Vis mindre",
		"cancel": "Avbryt",
		"search": "Søk",
		"send": "Sende",
		"done": "Ferdig",
		"password-requirements-hint": "Minst {{minLength}} tegn, ett tall, ett spesialtegn",
		"enter-your-email": "Skriv inn din email",
		"enter-your-username": "Skriv inn brukernavnet ditt",
		"create-a-password": "Lag et passord",
		"enter-your-password": "Skriv inn passordet ditt"
	},
	"login": {
		"dont-have-an-account": "Har du ikke en konto?",
		"forgot-password": "Glemt passord?",
		"sign-in": "Logg inn",
		"sign-up": "Melde deg på",
		"to-keep-connected-with-us-please-login-to-your-account": "For å holde kontakten med oss, vennligst logg inn på kontoen din",
		"welcome-back": "Velkommen tilbake",
		"please-enter-your-email-an-email-will-be-sent-to-it-to-reset-your-password": "Vennligst skriv inn din e-post, en e-post vil bli sendt til den for å tilbakestille passordet ditt",
		"create-new-password": "Opprett nytt passord",
		"set-new-password": "Angi nytt passord",
		"password-updated": "Passord oppdatert",
		"your-password-has-been-successfully-changed": "Ditt passord har blitt endret.",
		"password-set-successfully": "Passord satt",
		"you-can-login-now": "Du kan logge inn nå"
	},
	"register": {
		"create-account": "Opprett konto",
		"do-you-have-account": "Har du konto?",
		"repeat-password": "Gjenta passord",
		"agree-to": "Ved å opprette en konto godtar du vår",
		"privacy-policy-and-eula": "personvernerklæring og EULA",
		"provide-your-personal-details": "Oppgi dine personlige detaljer og begynn å utvikle deg med oss",
		"hello-friend": "Hei venn!",
		"sign-up-for-a-newsletter": "Abonner på vårt nyhetsbrev og bli en del av fellesskapet vårt!"
	},
	"forgot-password": {
		"sent-please-check-your-email": "Sendt, sjekk e-posten din"
	},
	"profile": {
		"delete-account": "Slett konto",
		"this-action-cannot-be-undone": "Denne handlingen kan ikke angres"
	},
	"validations": {
		"error": "Feil"
	},
	"change-password": {
		"modal": {
			"title": "Endre passord",
			"submit": "Endre passord"
		},
		"old-password": "Gammelt passord",
		"new-password": "Nytt passord",
		"repeat-new-password": "Gjenta nytt passord",
		"invalid-password": "Ugyldig passord",
		"passwords-do-not-match": "Passord stemmer ikke overens",
		"password-changed": "Passordet er endret",
		"new-password-must-be-different-from-the-old-one": "Nytt passord må være forskjellig fra det forrige"
	}
}
